import React, { Component } from 'react'
import { getChamp } from '../../utils/champsFunctions';

/* Cmponents */
import RotationContainerView from './RotationContainerView';

import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getUserByEmail } from '../../utils/usersFunctions';
import { getCompetitorsFromChamp, getTeams } from '../../utils/competitorsFunctions';

class RotationContainer extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            loadingRotationList: true,
            rotationList: [],

            rotationId: null,
            isScoreMan: false,
        }
    }

    componentWillMount = async () => {
        let arrayOfRoute = this.props.location.pathname.split('/')

        const champId = arrayOfRoute[3];
        this.setState({ champId })

        // Get specific champ object
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ,
        });

        // Get user type
        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                const userFound = await getUserByEmail(user.email);
                if (userFound.type === 'mesa') {
                    this.setState({ isScoreMan: true })
                }
            }
        })

        // Get list of rotation
        let localArrayOfRotations = []
        for (let i = 0; i < 20; i++) {
            localArrayOfRotations.push(i)
        }
        this.setState({
            rotationList: localArrayOfRotations,
            loadingRotationList: false
        })

        /* Get all competitors */
        let localArrayOfCompetitors = await getCompetitorsFromChamp(champId);
        sessionStorage.setItem('rotationArrayOfCompetitors', JSON.stringify(localArrayOfCompetitors));

        /* Get all teams */
        let localArray = await getTeams();
        sessionStorage.setItem('rotationArrayOfTeams', JSON.stringify(localArray));
    }

    chooseSwitching = (value) => {
        this.setState({
            rotationId: value
        })
    }

    render() {
        return (
            <RotationContainerView
                champObject={this.state.champObject}
                champId={this.state.champId}

                loadingRotationList={this.state.loadingRotationList}
                rotationList={this.state.rotationList}
                chooseSwitching={e => this.chooseSwitching(e)}

                rotationId={this.state.rotationId}
                isScoreMan={this.state.isScoreMan}
            />
        )
    }

}

export default RotationContainer